<template>
  <li :class="{ opened: isOpened }">
    <div
      class="header"
      @click="isOpened = !isOpened"
    >
      <h3>
        {{ option.question }}
      </h3>
      <minus-icon v-if="isOpened" />
      <plus-icon v-else />
    </div>

    <p
      v-if="isOpened"
      v-html="option.answer"
    ></p>
  </li>
</template>

<script>
import MinusIcon from '~/components/Common/Svg/MinusIcon';
import PlusIcon from '~/components/Common/Svg/PlusIcon';
export default {
  components: {
    PlusIcon,
    MinusIcon,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpened: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './FaqItem.scss';
</style>
